import axios from 'axios';

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

// Base URL for the Medical College Candidate API
const API_URL = getApiUrl('/MedicalCollege/');

// Create an Axios instance with default headers
const apiClient = axios.create({
    baseURL: API_URL,
});

// Add an interceptor to include the access token in the headers
apiClient.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
});

/**
 * Fetch all medical college candidates.
 * @returns {Promise} A promise that resolves to the list of candidates.
 */
export const fetchCandidates = (page = 1) => apiClient.get(`candidates/?page=${page}`);

/**
 * Fetch a single medical college candidate by ID.
 * @param {number} id - The ID of the candidate to fetch.
 * @returns {Promise} A promise that resolves to the candidate details.
 */
export const fetchCandidate = (id) => apiClient.get(`candidates/${id}/`);

/**
 * Create a new medical college candidate.
 * @param {Object} data - The data for the new candidate.
 * @returns {Promise} A promise that resolves to the created candidate.
 */
export const createCandidate = (data) => apiClient.post('candidates/', data);

/**
 * Update an existing medical college candidate.
 * @param {number} id - The ID of the candidate to update.
 * @param {Object} data - The updated data for the candidate.
 * @returns {Promise} A promise that resolves to the updated candidate.
 */
export const updateCandidate = (id, data) => apiClient.put(`candidates/${id}/`, data);

/**
 * Delete a medical college candidate.
 * @param {number} id - The ID of the candidate to delete.
 * @returns {Promise} A promise that resolves when the deletion is successful.
 */
export const deleteCandidate = (id) => apiClient.delete(`candidates/${id}/`);

/**
 * Filter medical college candidates based on various parameters.
 * @param {Object} filters - The filter parameters.
 * @returns {Promise} A promise that resolves to the filtered list of candidates.
 */
export const filterCandidates = (filters) => apiClient.get('filter-candidates/', { params: filters });
